// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h6[data-v-0b424b25]{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:2em;width:100%;text-align:center;padding:0 1rem}", ""]);
// Exports
module.exports = exports;
